import React, {useCallback, useRef, useState} from 'react';
import {HexColorPicker} from 'react-colorful';
import {useSelector} from 'react-redux';
import {Popover} from 'react-tiny-popover';
import {EyeDropIcon} from '~library/svg/EyeDropIcon';
import {selectEditorDisabled} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';

import './EyeDropper.sass';

export const EyeDropper = ({color, onChange}) => {
  const editorDisabled = useSelector(selectEditorDisabled);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  const toggleVisibility = useCallback(() => setIsVisible((prevState) => !prevState), []);

  return (
    <Popover
      ref={ref}
      isOpen={isVisible}
      positions={['top', 'bottom', 'left', 'right']}
      onClickOutside={toggleVisibility}
      content={<HexColorPicker color={color} onChange={onChange} />}
      containerClassName="eye_dropper"
      clickOutsideCapture
    >
      <button
        className="eye_dropper--button unstyled-button"
        onClick={editorDisabled ? undefined : toggleVisibility}
        disabled={editorDisabled}
        data-qa-id="step1-textcolor-add"
        type="button"
      >
        <EyeDropIcon ratio={1} />
      </button>
    </Popover>
  );
};
